import { Reducer } from "redux";

import {
    STROLLER_REVIEWS_FETCH_FAILURE,
    STROLLER_REVIEWS_FETCH_REQUEST,
    STROLLER_REVIEWS_FETCH_SUCCESS,
    StrollerReviewsFetchFailureAction,
    StrollerReviewsFetchRequestAction,
    StrollerReviewsFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/StrollerReviews/StrollerReviews.actions";
import { AST } from "@/mk2/apps/wiki/schemas";
import { tupdate } from "@/mk2/helpers/types";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface StrollerReviewsState {
    loadingState: LoadingState;
    strollerId: number | null;
    descriptionAST: AST;
    strollerReviewIds: number[];
    strollerPendingReviewIds: number[];
    strollerAlikeStrollerIds: number[];
    strollerReviewsActiveProductIds: number[];
}

export const initialStrollerReviewsState = {
    loadingState: LoadingState.INIT,
    strollerId: null,
    descriptionAST: null,
    strollerReviewIds: [],
    strollerPendingReviewIds: [],
    strollerAlikeStrollerIds: [],
    strollerReviewsActiveProductIds: [],
};

export interface StrollersReviewsState {
    [strollerSlug: string]: StrollerReviewsState;
}

const initialStrollersReviewsState: StrollersReviewsState = {};

declare type StrollerReviewsFetchAction =
    | StrollerReviewsFetchRequestAction
    | StrollerReviewsFetchSuccessAction
    | StrollerReviewsFetchFailureAction;

export const strollersReviewsReducer: Reducer<StrollersReviewsState> = (
    state = initialStrollersReviewsState,
    action: StrollerReviewsFetchAction,
) => {
    switch (action.type) {
        case STROLLER_REVIEWS_FETCH_REQUEST:
        case STROLLER_REVIEWS_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewsState, {
                    loadingState: loadingState(undefined, action),
                }),
            });
        }

        case STROLLER_REVIEWS_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                [strollerSlug]: tupdate(state[strollerSlug] || initialStrollerReviewsState, {
                    loadingState: loadingState(undefined, action),
                    strollerId: action.response.result.stroller,
                    descriptionAST: action.response.result.descriptionAST,
                    strollerReviewIds: action.response.result.strollerReviews,
                    strollerPendingReviewIds: action.response.result.strollerPendingReviews,
                    strollerAlikeStrollerIds: action.response.result.strollerAlikeStrollers,
                    strollerReviewsActiveProductIds:
                        action.response.result.strollerReviewsActiveProducts,
                }),
            });
        }

        default:
            return state;
    }
};
